import { AutocompleteInput, ReferenceInput } from "react-admin";

import React from "react";

const optionText = (option) =>
  option?.code ? `${option.code} - ${option.title}` : option?.title;

const ResearchProjectInput = ({ ...props }) => {
  return (
    <ReferenceInput
      {...props}
      reference="research-projects"
      sort={{ field: "title", order: "ASC" }}
    >
      <AutocompleteInput optionText={optionText} />
    </ReferenceInput>
  );
};
export default ResearchProjectInput;
